<template>
  <div class="photo-image">
    <div v-if="progress">
        <h2>{{ progress }}%</h2>
        <div class="progress">
          <div class="progress-bar" role="progressbar" :style="{width: progress + '%'}" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <br>
    </div>
    <form v-show="!progress" id="upload-entry">
        <div class="row">
            <div class="col-12">
                <p class="fw-bold">Kies op welke manier je een foto wilt uploaden</p>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label
                        for="customFile"
                        class="form-label"
                    >Uploaden bestanden vanaf je apparaat</label>
                    <div class="input-group">
                        <input
                            class="form-control"
                            id="customFile"
                            type="file"
                            accept="image/*"
                            multiple
                            v-on:change="showPreviews($event)"
                            ref="input"
                        />
                        <label class="input-group-text mt-0" for="customFile">Uploaden</label>
                    </div>
                </div>
            </div>
            <div class="col d-xxl-none">
                <div class="mb-3">
                    <label
                        for="customFile2"
                        class="form-label"
                    >Foto maken en direct uploaden</label>
                    <div class="input-group mb-3">
                        <input
                            class="form-control"
                            id="customFile2"
                            type="file"
                            accept="image/*"
                            capture="environment"
                            multiple
                            v-on:change="showPreviews($event)"
                            ref="input"
                        />
                        <label class="input-group-text mt-0" for="customFile">Camera</label>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div v-if="previewImages">
      <img v-bind:key="key" v-for="(preview, key) in previewImages" :src="preview" height="150">
    </div>
    <div v-if="error" v-text="error" class="text-danger"></div>
    <div
        v-if="!progress && previewImages.length > 0"
        class="d-grid gap-2 mt-3"
    >
      <button class="btn btn-primary" @click="upload()">Upload</button>
      <button class="btn btn-danger" @click="reset()">Verwijder selectie</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'photo-image',
  data () {
    return {
      progress: null,
      totalFileSize: null,
      previewImages: [],
      uploadedImages: [],
      files: null,
      filesArray: [],
      error: null
    }
  },
  watch: {
    uploadedImages: {
      handler (val) {
        if (this.filesArray.length === 0) {
          return
        }
        if (val.length === this.filesArray.length) {
          this.progress = 0
          this.$router.push('/photos/browse')
        }
      },
      deep: true
    }
  },
  methods: {
    upload () {
      const files = this.files
      this.error = null;
      this.filesLoaded = []
      this.totalFileSize = 0
      for (var i = 0; i < files.length; i++) {
        this.filesLoaded.push(0)
        this.totalFileSize += (files[i].size || files[i].fileSize)
        this.uploadPhoto(files[i], i)
      }
    },
    uploadPhoto (file, index) {
      const config = {
        onUploadProgress: progressEvent => this.updateTotalLoaded(progressEvent.loaded, index)
      }
      var formData = new FormData()
      formData.append('file', file)
      this.$request.post(
        '/deprecated/upload-photos?id_group=' + this.$store.getters.selectedGroupsQueryString,
        formData,
        config
      ).then((response) => {
        if (response?.data?.length > 0) {
          this.uploadedImages.push(response.data)
        } else {
          this.error = response.error
          // remove last created preview image, as the image failed to upload
          this.previewImages.splice(-1)
          this.reset();
        }
      })
    },
    showPreviews (event) {
      this.error = null;
      this.previewImages = []
      this.files = []
      for (var i = 0; i < event.target.files.length; i++) {
        this.previewImages.push(URL.createObjectURL(event.target.files[i]))
        this.files.push(event.target.files[i])
      }
    },
    updateTotalLoaded (fileLoaded, index) {
      this.filesLoaded[index] = fileLoaded
      var totalLoaded = 0
      for (var i = 0; i < this.filesLoaded.length; i++) {
        totalLoaded += this.filesLoaded[i]
      }
      this.setProgress((totalLoaded / this.totalFileSize) * 100)
    },
    setProgress (percentage) {
      percentage = percentage || 0
      percentage = parseInt(percentage)
      this.progress = percentage
    },
    reset () {
      this.progress = 0
      this.totalFileSize = null
      this.previewImages = []
      this.uploadedImages = []
      this.files = []
      this.filesArray = []
      // reset the state of the actual input field
      this.$refs.input.value = ''
    }
  }
}
</script>

<style scoped>
</style>
